<template>
    <!-- eslint-disable max-len -->
    <div id = "main">
        <div v-for="(item, index) in configData" :key="index">
          <h1 v-if="item.showName">{{item.name}}</h1>
          <employee v-for="(item2, index2) in item.empl" :key="index2"
          :imgSource="item2.photo"
          :description="item2.description"
          :EmpName="item2.name"
          :Website="item2.site"
          @openModal="showModal"
          />
          <br>
        </div>
    </div>
</template>

<script>
import employee from '@/components/employee.vue';

export default {
  name: 'employees',
  components: {
    employee,
  },
  data() {
    return {
      configData: this.$config.employees,
    };
  },

  methods: {
    showModal(imgSource, description, EmpName, Website) {
      this.$emit('modalOpen', imgSource, description, EmpName, Website);
    },
  },
};
</script>

<style scoped>
    #main {
        display: block;

        width:100%;
        height: 80%;
        background-color: white;
    }

    h1 {
      color: #333;
      border-bottom: 1px solid #333;
      max-width: 90%;
      margin: 20px auto;
    }
</style>
